export enum SitesRoutePathNames {
  SITES = 'sites',
  LIST = '',
  SITE = ':siteId',
  STATION_SCHEDULE = 'station-schedule',
  STATION = ':stationId',
  OVERVIEW = 'overview',
  MENU_HOURS = 'menu-hours',
  PICKUP_DETAILS = 'pickup-details',
  DROPOFF_DETAILS = 'dropoff-details',
  SALES = 'sales-channel',
  REPORTING = 'reporting',
  KDS = 'kds',
  FINANCIAL_CONFIG = 'financial-config',
  BUSINESS_UNIT = 'business-unit',
  BUSINESS_UNIT_ID = ':businessUnitId',
  STATION_DETAILS = 'station',
  INTEGRATION = 'integration',
  INTEGRATION_NAME = ':integration_name',
  NEXTEP = 'nextep',
  SETTINGS = 'site-settings',
  VOLANTE = 'volante',
  MASHGIN = 'mashgin',
  CENTRIC_HUB = 'centric-hub',
  INTEGRATION_TYPE = ':integrationType',
  RECOMMENDATION_DETAILS = 'recommendation-details',
  CENTRIC_POS = 'centric-pos',
}
